import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { AppConfigService } from 'src/app/core/services/config.service';
import { CustomResult, HelpFileTypes } from '../../../../../../core/api/models';
import { MenusService } from '../../../../../../core/api/services/menus.service';
import { DialogService } from '../../../../../../core/services/dialog.service';
import { BaseFormPageComponent } from '../../../../../../pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    imports: [BaseFormModule, ModalTitleComponent]
})
export class FileUploadComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  action: string = AppConfigService.config.apiUrl + '/Menus/UploadHelpFiles';
  menuId: number;
  helpFileType: HelpFileTypes = HelpFileTypes.Image;
  selectedFile;
  acceptedFileTypes: string;

  get FileType() {
    return HelpFileTypes;
  }

  imageFileTypes = '.png,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.svg';
  videoFileTypes = '.webm,.mkv,.avi,.mp4';
  pdfFileTypes = '.pdf';
  fileTypes = '.zip,.rar';

  //#endregion

  constructor(
    protected currentService: MenusService,
    public dialogService: DialogService,

    public http: HttpClient,
    private dialogRef: MatDialogRef<FileUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.menuId = data;
    this.acceptedFileTypes = this.imageFileTypes;
  }

  ngOnInit() {
    this.initForm();
    this.fields = 'pages.menus.uploadFileForm.fields.';
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      file: new FormControl('', Validators.required),
      helpFileType: new FormControl('', Validators.required),
    });
  }

  //#region api

  uploadHelpFilesApi() {
    try {
      this.unSubs();
      this.loading = true;

      let formData: any = new FormData();
      let fileToUpload = <File>this.selectedFile;

      formData.append('menuId', this.menuId.toString());
      formData.append(
        'file',
        fileToUpload,
        fileToUpload.name.replace(/\s/g, '')
      );
      formData.append('helpFileType', this.helpFileType);

      const headers = new HttpHeaders()
        .set('Accept', 'application/json')
        .set('enctype', 'multipart/form-data');

      this.http
        .post<CustomResult>(this.action, formData, { headers: headers })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseObserver);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  getFile(file) {
    this.selectedFile = file;
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.uploadHelpFilesApi();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getAcceptedFiles(helpFileType) {
    try {
      this.acceptedFileTypes =
        helpFileType == this.FileType.Pdf
          ? this.pdfFileTypes
          : helpFileType == this.FileType.Video
          ? this.videoFileTypes
          : helpFileType == this.FileType.Image
          ? this.imageFileTypes
          : this.fileTypes;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onClose() {
    this.dialogRef.close(false);
    this.unSubs();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
